import { createTheme } from "@mui-wrapper";
import { Color } from "@styles/default-colors";
import { flatUiThemeOptions, grey } from "@flat-ui";

/**
 * The app's theme: the flat-ui theme plus the layout and the tab bar the app itself needs. Colours,
 * typography and the rest of the component styling come from flat-ui.
 */
export const hbTheme = createTheme(flatUiThemeOptions, {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // eslint-disable-next-line @typescript-eslint/naming-convention -- naming on html class
        "#root": {
          display: "flex",
          flexDirection: "column",
        },

        // eslint-disable-next-line @typescript-eslint/naming-convention -- naming on html class and tag
        "body, #root": {
          height: "100vh",
        },

        main: {
          height: "100%",
        },
      },
    },

    // The grey tab bar the admin pages are built around, which flat-ui's tabs do not draw
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: Color.grey39,
          paddingLeft: "116px",

          "& button": {
            color: grey[0],
            textTransform: "capitalize",

            "&.Mui-selected": {
              backgroundColor: grey[0],
              color: Color.grey52,
            },
          },
        },
        indicator: {
          display: "none",
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          "&:first-of-type": {
            paddingLeft: "50px",
          },
        },
      },
    },
  },
});
